import styles from './style.module.css';

function CustomTabs({ tabs, activeTab, className = '' }) {
  return (
    <div className={`${styles.customTabs} ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tabButton} ${activeTab === tab.key ? styles.activeTab : ''}`}
          onClick={tab.onClick}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default CustomTabs;